<template>
  <div class="base-date" :style="{ ...position, ...customStyle }" :class="[isEmpty(position) ? '' : 'absolute-el']" :flex="flex">
    <span class="date" :style="{ ...options.date.style }">{{ todayDate }}</span>
    <span class="week" :style="{ ...options.week.style }">{{ todayWeek }}</span>
    <span class="second" :style="{ ...options.second.style }">{{ todaySecond }}</span>
  </div>
</template>

<script lang="ts" setup>
import { isEmpty } from "lodash-es"
import moment from "moment"
import { onMounted, onBeforeUnmount, ref, computed } from "vue"
import dataConfig from "./props-data"

const WEEK_DAY_ARR: string[] = ["一", "二", "三", "四", "五", "六", "日"]

type DateOptions = {
  date: {
    position: any
    fmt: string
    style?: any
  }
  week: {
    position: any
    prefix: string
    style?: any
  }
  second: {
    position: any
    fmt: string
    style?: any
  }
}

type BaseDateComponent = {
  position?: any
  options?: DateOptions
  customStyle?: any | undefined
  flex: string
}

const props = withDefaults(defineProps<BaseDateComponent>(), {
  position: () => dataConfig.position,
  options: () => dataConfig.options,
  customStyle: undefined,
  flex: () => "dir:left main:justify cross:center",
})

const todayDate = computed(() => (nowDate.value ? nowDate.value.format(props.options.date.fmt) : ""))

const todayWeek = computed(() => (nowDate.value ? `${props.options.week.prefix}${WEEK_DAY_ARR[nowDate.value.isoWeekday() - 1]}` : ""))
const todaySecond = computed(() => (nowDate.value ? nowDate.value.format(props.options.second.fmt) : ""))

// 当前时间
let nowDate = ref<ReturnType<typeof moment>>(moment())

// 定时器id
let timerLoop: ReturnType<typeof setTimeout>

/**
 * 刷新时间
 */
function refreshTime(): void {
  if (timerLoop) {
    clearTimeout(timerLoop)
  }

  nowDate.value = moment()
  timerLoop = setTimeout(refreshTime, 850)
}

onMounted(() => {
  refreshTime()
})

onBeforeUnmount(() => {
  clearTimeout(timerLoop)
})
</script>

<style lang="scss" scoped>
.base-date {
  color: #fff;

  .date {
    letter-spacing: 1.6px;
  }

  .second {
    letter-spacing: 1px;
    margin-left: 10px;
  }
}
</style>
